export default {
  name: 'switcher',
  label: '开关',
  dataType: 'Boolean',
  icon: 'el-icon-turn-off',
  config: [{
    xtype: 'switcher',
    options: {
      label: '默认值',
      name: 'defaultVal',
      placeholder: '设置表单默认值'
    }
  }]
};